import { CaseStudies, CaseStudiesFilter } from '@/entities/caseStudies'
import HTTP from '@/plugin/http'
import { toPlainObject } from '@utils'
import { get } from 'lodash-es'
import { caseStudiesPageSize, MenuStyles } from '../config'
import CaseStudiesRoute from '../routes/caseStudies'
import { getMenuByStyle } from './menu'

export async function caseStudiesList(query?: string, pageIndex?: number) {
  const { route, ...params } = parseQuery(query)
  const menu = await getMenuByStyle(MenuStyles.caseStudies)
  const { data, total } = await HTTP.create('about-us/contents', CaseStudies)
    .withParams({
      limit: caseStudiesPageSize,
      offset: ((pageIndex || params.page) - 1) * caseStudiesPageSize,
      industryId: params.industry,
      location: params.location,
      menuId: get(menu, 'id'),
    })
    .array()
  return { data: toPlainObject(data), total, params, route }
}

export async function caseStudiesDetail(slug: string) {
  const data: CaseStudies = await HTTP.create(
    `about-us/contents/${slug}`,
    CaseStudies
  ).json()
  return toPlainObject(data)
}

export async function caseStudiesFilter() {
  const data = await HTTP.create(
    'about-us/contents-filters',
    CaseStudiesFilter
  ).json()
  return toPlainObject(data)
}

export function parseQuery(query?: string) {
  const route = new CaseStudiesRoute()
  if (query) {
    route.fromSlug(query)
  }

  let location
  if (route.getVal('location')) {
    location = (route.getVal('location') as string).split('-').pop()
  }
  let industry
  if (route.getVal('industry')) {
    industry = (route.getVal('industry') as string).split('-').pop()
  }
  let page
  if (route.getVal('page')) {
    page = Number(route.getVal('page'))
  } else {
    page = 1
  }

  return {
    location,
    industry,
    page,
    route,
  }
}
